export default __webpack_public_path__ + "static/media/external-link-icon.48c6bccc.svg";